<template>
  <vs-popup
    v-if="passData !== null"
    fullscreen
    :title="`Sub-Menu dari Menu ${passData.name}`"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <div class="vx-row justify-between mt-2 w-full">
      <section class="vx-col lg:w-2/5 sm:w-full">
        <main>
          <div class="mb-6 items-top">
            <section class="vx-row">
              <span
                :class="
                  itemEdit === null
                    ? 'text-black text-xl vx-col w-full'
                    : 'text-black text-xl vx-col w-4/5 overflow-visible'
                "
                ><strong>{{ titlePopUp }}</strong></span
              >
              <vs-icon
                v-if="itemEdit !== null"
                class="vx-col w-1/5 cursor-pointer"
                icon="clear"
                size="medium"
                color="#383838"
                @click="closeEdit"
              ></vs-icon>
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-4 flex justify-start gap-1">
              <h6><strong>Menu</strong></h6>
              <span class="text-danger">*</span>
            </section>
            <v-select
              :options="listMenu"
              class="w-full"
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="menu"
              label="name"
              v-model="formData"
              placeholder="Pilih Menu Lokal"
            />
            <span class="text-danger text-sm">{{ errors.first("menu") }}</span>
          </div>
          <div class="mb-6">
            <section class="mb-4 flex justify-start gap-1">
              <h6><strong>Urutan</strong></h6>
              <span class="text-warning">(Option)</span>
            </section>
            <vs-input
              type="number"
              name="urutan"
              class="w-full sidebar-input"
              v-model="urutan"
              placeholder="Isi nomor urutan"
            />
            <span class="text-danger text-sm">{{ errors.first("urutan") }}</span>
          </div>
          <div class="mb-4">
            <section class="mb-2 flex justify-start gap-1">
              <h6>Parent Menu</h6>
            </section>
            <vs-input
              v-if="passData.name"
              v-validate="'required'"
              data-vv-validate-on="blur"
              class="w-full sidebar-input"
              :disabled="true"
              v-model="passData.name"
              placeholder="Isi Dengan Nama Parent Menu"
            />
          </div>
        </main>
        <footer class="mt-4">
          <div class="flex justify-end items-center mr-4 mb-4">
            <!-- <vs-button
          color="danger"
          class="mr-2 rounded-2xl"
          @click="closeWithLoad(false)"
          >Cancel</vs-button
        > -->
            <vs-button
              :color="itemEdit === null ? 'success' : 'warning'"
              class="ml-2 rounded-2xl"
              :disabled="!validateForm"
              @click="addData"
              >{{ labelButton }}</vs-button
            >
          </div>
        </footer>
      </section>
      <section class="vx-col lg:w-3/5 sm:w-full">
        <header class="w-full">
          <div class="mb-base vx-row justify-between items-top">
            <section
              class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start"
            >
              <span class="text-black text-xl"><strong>Tabel Submenu</strong></span>
            </section>
            <!-- <section
              class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end"
            >
              <vs-button @click="openPopUp(null)" v-if="access.create === 1"
                >Tambah Kategori Campaign</vs-button
              >
            </section> -->
          </div>
          <div class="vx-row justify-between items-center">
            <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
              <div class="w-full gap-2 flex justify-start items-center">
                <vs-button @click="actionsDelete">{{
                  selected.length === 0 ? "Hapus" : `Hapus ${selected.length} Item`
                }}</vs-button>
                <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <vs-button icon-after icon="expand_more">Aksi</vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="dialogDelete">
                      <span>Hapus</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2">{{ `entries ${limit}` }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item
                      v-for="(item, index) in limitDataTables"
                      :key="index"
                      @click="limit = item"
                    >
                      <span>{{ item }}</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown> -->
              </div>
            </section>
            <!-- <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
              <div class="w-full flex justify-end gap-2 flex-wrap items-center">
                <vs-input v-model="search" placeholder="Search..." />
              </div>
            </section> -->
          </div>

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <div
            class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
          ></div>
        </header>

        <main ref="loadSubMenus">
          <vs-table
            stripe
            :data="subMenus"
            v-model="selected"
            :max-items="limit"
            multiple
          >
            <template slot="thead">
              <vs-th>Nama Submenu</vs-th>
              <vs-th>URL</vs-th>
              <vs-th>Aksi</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>
                <vs-td :data="data[indextr].url">
                  {{ data[indextr].url }}
                </vs-td>
                <vs-td>
                  <div
                    class="flex justify-start gap-2"
                    v-if="itemDelete !== data[indextr].id"
                  >
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-edit"
                      @click="openEdit(data[indextr])"
                    >
                    </vs-button>
                    <vs-button
                      color="danger"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="itemDelete = data[indextr].id"
                    >
                    </vs-button>
                  </div>
                  <div class="flex justify-start gap-2" v-else>
                    <vs-button
                      color="danger"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="deleteItem(data[indextr].id)"
                    >
                      Delete
                    </vs-button>
                    <vs-button
                      color="#949494"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-x"
                      @click="itemDelete = null"
                    >
                      No
                    </vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </main>
        <footer>
          <div class="justify-end mt-2">
            <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
          </div>
        </footer>
      </section>
    </div>
  </vs-popup>
</template>

<script>
import limitDataTables from "@/limitDataTable.js";
import listMenu from "@/layouts/components/vertical-nav-menu/navMenuItems.js";

export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      listMenu,
      params: {},
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      itemDelete: null,
      itemEdit: null,
      selected: [],
      access: null,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      subMenus: [],
      search: "",
      pagination: {
        start: 0,
        length: limitDataTables[0],
      },
      currentPg: 1,
      formData: null,
      urutan: 1,
    };
  },
  computed: {
    titlePopUp() {
      return this.itemEdit != null ? "Edit Submenu" : "Tambah Submenu ";
    },
    labelButton() {
      return this.itemEdit != null ? "Edit" : "Submit";
    },
    validateForm() {
      return !this.errors.any() && this.formData !== null;
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
    totalPage() {
      let pages = this.subMenus.length / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.subMenus = this.passData.sub_menu;
      } else {
        this.subMenus = [];
      }
    },
    search() {
      if (this.search !== "") {
        this.params = {
          search: this.search,
          filter: "name",
        };
      } else {
        this.params = {};
      }

      this.getData();
    },
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.getData();
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.getData();
    },
  },
  methods: {
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    openEdit(val) {
      this.formData = {
        name: val.name,
        icon: val.icon,
        url: val.url,
        i18n: val.i18n,
      };
      this.urutan = val.urutan;
      this.itemEdit = val;
    },
    closeEdit() {
      this.formData = null;
      this.urutan = 1;
      this.itemEdit = null;
    },
    actionsDelete() {
      if (this.selected.length === 0) {
        this.$vs.notify({
          title: "Tidak ada item yang dipilih",
          text: "Pilihlah salah satu item atau semua item",
          color: "danger",
          position: "top-right",
        });
      } else {
        for (let i in this.selected) {
          this.deleteItem(this.selected[i].id);
        }
      }
    },
    // dialogDelete(val) {

    //   this.$vs.dialog({
    //     type: "confirm",
    //     color: "danger",
    //     title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
    //     text:
    //       name && id
    //         ? `Anda yakin ingin menghapus item ${name}`
    //         : "Anda yakin ingin menghapus item yang terpilih",
    //     accept: () => {
    //       if (name && id) {
    //         this.delete(id);
    //       } else {
    //         // eslint-disable-next-line no-lonely-if
    //         if (this.selected.length === 0) {
    //           this.$vs.notify({
    //             title: "Tidak ada item yang dipilih",
    //             text: "Pilihlah salah satu item atau semua item",
    //             color: "danger",
    //             position: "top-right",
    //           });
    //         } else {
    //           // eslint-disable-next-line prefer-const
    //           for (let i in this.selected) {
    //             this.delete(this.selected[i].id);
    //           }
    //         }
    //       }
    //     },
    //   });
    // },
    deleteItem(id) {
      this.$vs.loading({
        container: this.$refs.loadSubMenus,
        color: "primary",
      });
      this.closeEdit();
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("menus/cudSubMenus", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Submenu ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.selected = [];
          this.getData();
          this.itemDelete = null;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadSubMenus);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadSubMenus,
        color: "primary",
      });
      this.$store
        .dispatch("menus/getMenus", { id: this.passData.id })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadSubMenus);
          this.subMenus = v.sub_menu;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadSubMenus);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let idData = {};
      if (this.itemEdit !== null) {
        idData = {
          id: this.itemEdit.id,
        };
      } else {
        idData = {};
      }
      if (this.urutan === null || this.urutan === "") {
        this.urutan = 1;
      }
      this.$store
        .dispatch("menus/cudSubMenus", [
          { ...this.formData, menu_id: this.passData.id, ...idData, urutan: this.urutan },
        ])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.itemEdit !== null
                ? "Edit Submenu Sukses!"
                : "Tambah Submenu ZIS Sukses!",
            text:
              this.itemEdit !== null
                ? `Submenu ${v.name} Berhasil diedit`
                : `Submenu ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          idData = {};
          this.selected = [];
          this.closeEdit();
        });
    },
  },
  created() {
    // if (this.$store.state.auth.profileAccess !== null) {
    //   if (
    //     this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/sub-kategori-campaign"
    //     )
    //   ) {
    //     this.access = this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/sub-kategori-campaign"
    //     );
    //   }
    // }
  },
};
</script>
